import Vue from 'vue'
import {
  Button,
  Row,
  Col,
  Form,
  FormItem,
  Input,
  Cascader,
  Select,
  // Switch,
  Option,
  Message,
  MessageBox,
  Loading,
  Scrollbar,
  Menu,
  MenuItemGroup,
  Submenu,
  MenuItem,
  Tooltip,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,

  Table,
  TableColumn,
  Tag,
  Card,
  Pagination,
  Dialog,
  DatePicker,
  Tree,
  Link,
  TimePicker,
  TimeSelect,
  Collapse,
  CollapseItem,
  Tabs,
  TabPane,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup
} from 'element-ui'
Message.install = () => {
  Vue.prototype.$message = Message
}
MessageBox.install = () => {
  Vue.prototype.$confirm = MessageBox.confirm
}
// Notification.install = () => {
//   Vue.prototype.$notify = Notification
// }

Vue.use(Button)
Vue.use(Row)
Vue.use(Col)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Cascader)
Vue.use(Message)
Vue.use(MessageBox)
Vue.use(Loading)
// Vue.use(Notification)
Vue.use(Scrollbar)
Vue.use(Menu)
Vue.use(MenuItemGroup)
Vue.use(Submenu)
// Vue.use(Switch)
Vue.use(MenuItem)
Vue.use(Tooltip)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Tag)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(DatePicker)
Vue.use(Select)
Vue.use(Option)
Vue.use(Tree)

Vue.use(Link)
Vue.use(TimePicker)
Vue.use(TimeSelect)
Vue.use(Collapse)
Vue.use(CollapseItem)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Checkbox)
Vue.use(CheckboxGroup)
Vue.use(Radio)
Vue.use(RadioGroup)
